import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assigned", "unassigned", "assignedTab", "unassignedTab", "allTab", "submitButton"]

  connect() {
    this.initializeTabs()
    this.bindEvents()
  }

  bindEvents() {
    window.addEventListener("remote_lock:enable-submit-button", this.enableSubmitButton.bind(this))
  }

  disconnect() {
    window.removeEventListener("remote_lock:enable-submit-button", this.enableSubmitButton.bind(this))
  }

  showAssigned() {
   this.hideItems(this.unassignedTargets)
   this.showItems(this.assignedTargets)
   this.triggerSearch()
  }

  showUnassigned() {
    this.showItems(this.unassignedTargets)
    this.hideItems(this.assignedTargets)
    this.triggerSearch()
  }

  showAll() {
   this.showItems(this.unassignedTargets)
   this.showItems(this.assignedTargets)
   this.triggerSearch()
  }

  hideItems(items) {
    items.forEach(item => {
      item.classList.add("hidden")
      item.classList.remove("tabFiltered")
    })
  }

  showItems(items) {
    items.forEach(item => {
      item.classList.remove("hidden")
      item.classList.add("tabFiltered")
    })
  }

  triggerSearch() {
    const event = new CustomEvent("remote_lock:apply-search")

    window.dispatchEvent(event)
  }

  enableSubmitButton() {
    this.submitButtonTargets.forEach(submit => submit.disabled = false)
  }

  initializeTabs() {
    if (this.unassignedTargets.length > 0) {
      this.showUnassigned()
      this.unassignedTabTarget.classList.add("active")
    }
    else {
      this.showAll()
      this.allTabTarget.classList.add("active")
    }
  }

  fetchLocksByLocation(event) {
    window.location.search = "location=" + event.target.value
  }
}
